import { createReducer, on } from '@ngrx/store';

import { Farm } from 'src/app/models/farm/farm.model';
import { farmSuccessFulyLoaded, farmUpdateSuccess, updateFarm, updateFarmPrivacy } from '../actions/farm.action';

export const initialState: Farm = new Farm();

export const farmReducer = createReducer(
  initialState,
  on(farmSuccessFulyLoaded, (state, { farm }) => farm),
  on(updateFarm, (state, action) => {
    return action.data;
  }),
  on(updateFarmPrivacy, (state, action):any => {
    return {
      ...state,
      privacy: action.privacy,
    }
  }),
  on(farmUpdateSuccess, (state, action):any => {
    return {
      ...state,
      ...action.data,
    }
  }),
);
